export default __webpack_public_path__ + "static/media/phones-full.8b214935.png";